import init from "@/javascripts/shared/utils/init"
import intlTelInput from "intl-tel-input"

init(() => {
  const baseUrl = window.location.origin
  const phoneInputEls = document.querySelectorAll(`.js--phone-input`)

  phoneInputEls.forEach((el) => {
    const iti = intlTelInput(el, {
      loadUtils: () =>
        import(`${baseUrl}/static/vendor/intl-tel-input-utils.js`),
      initialCountry: `se`,
      separateDialCode: false,
    })

    // Update phone number with country code whenever country changes
    el.addEventListener(`countrychange`, () => {
      if (el.value) {
        const fullNumber = iti.getNumber()
        if (fullNumber) {
          el.value = fullNumber
        }
      }
    })
  })
})
